import { AppSettings } from './../app.settings';
import * as momentImported from 'moment';
const moment = (momentImported as any).default || momentImported;

export function formatDateCell(timestamp) {
  if (timestamp && timestamp > 0) {
    return moment(timestamp).format(AppSettings.DATE_TIME_FORMAT_MOMENT);
  } else {
    return 'NA';
  }
}
export function formatDateTimeAMPMCell(timestamp) {
  if (timestamp && timestamp > 0) {
    return moment(timestamp).format(AppSettings.DATE_TIME_AM_PM_FORMAT_MOMENT);
  } else {
    return '-';
  }
}


export function formatTimeCell(timestamp) {
  return moment(timestamp).format(AppSettings.DEFAULT_TIME_FORMATE);
}

export function toLocalDateAndtime(timeStamp) {
  const now = new Date(timeStamp);
  const localTime = new Date(timeStamp + now.getTimezoneOffset() * 60000);
  return moment(localTime).format(AppSettings.DATE_TIME_FORMAT_MOMENT);
}

export function getDate(timestamp) {
  return moment(timestamp).format(AppSettings.DATE_ONLY_FORMATE);
}

export function getUTCDate(timestamp) {
  const duration = moment.duration(timestamp, 'milliseconds');
  // Get hours, minutes, and seconds from the duration
  const hours = ('00' + Math.floor(duration.asHours()).toString()).slice(-2);
  const minutes = ('00' + duration.minutes().toString()).slice(-2);
  const seconds = ('00' + duration.seconds().toString()).slice(-2);
  return `${hours}:${minutes}:${seconds}`;
}






export function formatTimeCellToMin(timestamp) {
  return moment(timestamp).format(AppSettings.DEFAULT_TIME_FORMATE);
}


